import React, { Component } from 'react';
import { connect } from 'react-redux';
import BrandDetailWrap from '../../views/brand/detail/BrandDetailWrap';
import { brandActions } from '../../store/modules/brand';
import { BRAND_DETAIL_STATISTIC_KEYWORD_MODEL } from '../../store/modules/brand/models';

class BrandDetailContainer extends Component {
  /**
   *  다른 페이지 이동 시 통계 데이터 초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['brandDetail', 'statistic', 'keyword'],
      value: BRAND_DETAIL_STATISTIC_KEYWORD_MODEL,
    });
    setData({
      path: ['brandDetail', 'statistic', 'data'],
      value: [],
    });
  }

  render() {
    const { storeId, setData } = this.props;

    return <BrandDetailWrap storeId={storeId} setData={setData} />;
  }
}

const mapDispatchToProps = {
  setData: brandActions.setData,
};

export default connect(null, mapDispatchToProps)(BrandDetailContainer);
